import React from 'react'
import ButtonAnimated from '../../buttons/ButtonAnimated'
import { translate } from '../../../utils/useful'
import FormViewer from '../../FormViewer'

class UPS extends React.Component {
    state = {

        fields: [
            { key: 'account', type: 'TextInput', col: '6', information: { label: '{{lang}}UPS Account Number', placeholder: '', required: true } },
            { key: 'invoiceNumber', type: 'TextInput', col: '6', information: { label: '{{lang}}UPS Invoice Number', placeholder: '', required: false } },
            { key: 'invoiceDate', type: 'DateInput', col: '6', information: { label: '{{lang}}UPS Invoice Date', placeholder: '', required: false } },
            { key: 'invoiceAmount', type: 'NumberInput', col: '6', information: { label: '{{lang}}UPS Invoice Amount', placeholder: '', required: false } },
            { key: 'invoiceControlId', type: 'TextInput', col: '6', information: { label: '{{lang}}Invoice Control ID', placeholder: '', required: false } },
            { key: 'address', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}Address',rows:5, placeholder: '', required: false } },

        ]
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value, this.props.extra)
        }
    }

    componentDidMount() {
        // console.log('this.props.data', this.props?.data)
    }
    focus = () => {
        this.input.focus()
    }
    selectHandler = () => {

    }

    submitForm = () => {
        let data = this.form.getForm()
    }


    render() {
        let info = this.props.header?.information

        return (
            <div className="w-100 h-100  pt-2 pb-4"  >
                <div className='flexc px-3 pb-3' style={{borderBottom:'1px solid #eee'}}>
                    <div className='flexcc'>
                        <img src='/assets/ups.svg' height={50} />
                    </div>
                    <div className='mld-4'>
                        <p className='text-bold text-normal'>{translate("Connect to your UPS account")}</p>
                        <a className='text-link text-small' href='https://www.ups.com/' target='_blank' rel="noreferrer">{translate("Don't have an account? Click here")}</a>
                    </div>
                </div>

                <div className='mt-3 px-3'>
                    <div className='text-small br-8 p-3' style={{ backgroundColor: '#007aff10' }}>
                        <p className='text-bold mb-1'>Note</p>
                        <p >- Yonnect creates a sub-account of your original UPS account.</p>
                        <p>- You must provide the details of any one of the three most recent Delivery Service Invoices generated within the last 90 days.</p>
                        <p>- If your account is new or if you have not generated any invoice within the last 90 days these details are not mandatory.</p>
                    </div>
                </div>


                <div className='mt-4'>
                    <FormViewer ref={el => this.form = el} headers={this.state.fields} formClass="bordered-form" inputClass={'bordered-input'} />
                </div>


                <div className='mt-0 px-3'>
                    <ButtonAnimated
                        icon={'/assets/icons/angle-right-white2.svg'}
                        bg={'linear-gradient(to right, rgb(124, 122, 255), rgb(88, 86, 214))'}
                        textColor={'#fff'}
                        title={'{{lang}}Connect with UPS'}
                        invert={false}
                        onClick={() => this.submitForm()}
                    />
                </div>
            </div>
        )
    }
}

export default UPS;